import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService, GenesisUnitOfWork, SessionInformationService } from 'app/core/core.module';
import { SharedModule } from 'app/shared/shared.module';
import { DxDataGridComponent } from 'devextreme-angular';

@Component({
    selector: 'app-user-search',
    templateUrl: './user-search.component.html',
    styleUrls: ['./user-search.component.scss'],
    standalone: false
})
export class UserSearchComponent implements OnInit {
    uow = inject(GenesisUnitOfWork);
    router = inject(Router);
    auth = inject(AuthService);
    sessionInfo = inject(SessionInformationService);

    entities: any[];
    showAll: boolean;

    @ViewChild('dataGrid') dataGrid: DxDataGridComponent;
    onExporting = SharedModule.onExporting;

    async ngOnInit() {
        const showAll = this.sessionInfo.getItem('user-search-filter');
        if (showAll != null) this.showAll = showAll;
        await this.getData();
    }

    async getData() {
        const entities = await this.uow.getUsers('userRoles.role', { active: !this.showAll });
        if (this.auth.currentUser.userName !== 'mreimink') {
            this.entities = entities.filter((x) => {
                return x.userName !== 'mreimink';
            });
        } else this.entities = entities;
    }

    async toggleShowAll() {
        this.showAll = !this.showAll;
        await this.getData();
        this.sessionInfo.setItem('user-search-filter', this.showAll);
    }

    selectionChange(e) {}

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                location: 'before',
                template: 'toolbarButtons',
            },
            {
                template: 'toolbarText',
                location: 'after',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'revert',
                    elementAttr: { title: 'Reset Filters' },
                    onClick: () => {
                        e.component.clearFilter();
                    },
                },
                location: 'after',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'refresh',
                    elementAttr: { title: 'Reset Grid Layout' },
                    onClick: () => {
                        e.component.state({});
                    },
                },
                location: 'after',
            }
        );
    }

    async open(id: number) {
        this.router.navigate(['/admin/users/' + (!!id ? id : 'new')]);
    }

    async rowDoubleClick(e) {
        if (!e.data || !e.data.id) return;
        this.open(e.data.id);
    }
}
